<pdq-card variant="flat" color="white">
  <pdq-expandable-section
    id="multi-shipment-line-item-assignment-status"
    [cacheState]="true"
    [initialCollapsed]="false">
    <div sectionHeader class="section-heading">
      <pdq-heading element="h6">Line Item Assignment Status</pdq-heading>
      <p class="body-12-regular section-heading__subtitle">
        Read-only status pills inside cart line items showing per-item allocation.
      </p>
    </div>

    <div class="assignment-status" [formGroup]="formGroup">
      <div class="pill" formGroupName="assigned">
        <pdq-input
          label="Assigned pill label"
          formControlName="label"
          [placeholder]="'{quantity}× To {name} (#{number})'"
          [mentionVariables]="assignedLabelVariables"
          [invalid]="
            formGroup.controls.assigned.controls.label.dirty && formGroup.controls.assigned.controls.label.invalid
          "
          invalidMsg="Pill label is required"></pdq-input>
        <div class="pill__styles">
          <pdq-input-color
            label="Background color"
            [clearable]="true"
            [control]="assignedBackgroundColorControl"
            [formControl]="assignedBackgroundColorControl"
            (cleared)="onAssignedBackgroundColorCleared()"></pdq-input-color>
          <pdq-input-color
            label="Text color"
            [clearable]="true"
            [control]="assignedTextColorControl"
            [formControl]="assignedTextColorControl"
            (cleared)="onAssignedTextColorCleared()"></pdq-input-color>
          <pdq-dropdown
            title="Corner Radius"
            [options]="cornerRadiusOptions"
            [defaultOption]="assignedCornerRadiusOption()"
            [useOverlay]="true"
            (onChange)="onAssignedCornerRadiusChange($event)"></pdq-dropdown>
        </div>
      </div>

      <div class="pill" formGroupName="unassigned">
        <pdq-input
          label="Unassigned pill label"
          formControlName="label"
          [placeholder]="'{quantity}× Unassigned'"
          [mentionVariables]="unassignedLabelVariables"
          [invalid]="
            formGroup.controls.unassigned.controls.label.dirty && formGroup.controls.unassigned.controls.label.invalid
          "
          invalidMsg="Pill label is required"></pdq-input>
        <div class="pill__styles">
          <pdq-input-color
            label="Background color"
            [clearable]="true"
            [control]="unassignedBackgroundColorControl"
            [formControl]="unassignedBackgroundColorControl"
            (cleared)="onUnassignedBackgroundColorCleared()"></pdq-input-color>
          <pdq-input-color
            label="Text color"
            [clearable]="true"
            [control]="unassignedTextColorControl"
            [formControl]="unassignedTextColorControl"
            (cleared)="onUnassignedTextColorCleared()"></pdq-input-color>
          <pdq-dropdown
            title="Corner Radius"
            [options]="cornerRadiusOptions"
            [defaultOption]="unassignedCornerRadiusOption()"
            [useOverlay]="true"
            [overlayPositions]="dropUpOverlayPositions"
            (onChange)="onUnassignedCornerRadiusChange($event)"></pdq-dropdown>
        </div>
      </div>
    </div>
  </pdq-expandable-section>
</pdq-card>
